<template>
  <div>
    <h1 class="title">Ora passiamo alla personalizzazione della pappa</h1>

    <p class="subtitle">
      Scegli quale metodo di preparazione preferisci per la pappa di
      {{ dogData.name | capitalize }}.<br />
      L’unica differenza tra cotto e crudo è che il cotto
      <strong>potrai conservarlo fuori dal frigo</strong>!<br />
      <strong>Semplice</strong> come le crocchette,
      <strong>sano come la Pappa Fresca</strong>!
    </p>

            <a
          class="md:hidden underline inline-block text-sm italic py-2 cursor-pointer"
          v-on:click.stop="openModal()"
          >Maggiori info</a>
    <form class="form" @submit.prevent>
      <div class="form-group">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
          <label
            v-for="fpm in foodPreparationMethods"
            :key="fpm.id"
            :for="fpm.id"
            class="p-4 rounded-xl border-2 border-solid border-gray-300"
            :class="[
              form.foodPreparationMethodId == fpm.id
                ? 'big-active-option'
                : 'big-inactive-option',
            ]"
          >
            <input
              v-model.number="$v.form.foodPreparationMethodId.$model"
              class="hidden"
              :id="fpm.id"
              type="radio"
              :value="fpm.id"
            />
            <div
              class="w-32 h-32 mx-auto overflow-hidden rounded-full"
              v-if="fpm.name == 'Cotto'"
            >
              <img
                :src="getImageUrl('questionario_cotto.gif')"
                alt=""
              />
            </div>
            <div class="w-32 h-32 mx-auto overflow-hidden rounded-full" v-else>
              <img
                :src="getImageUrl('questionario_crudo.gif')"
                alt=""
              />
            </div>
            <div class="option-btn rb-subtitle-font">
              {{ fpm.name }}
            </div>

            <div class="mt-4" v-if="fpm.name == 'Cotto'">
              <div class="leading-tight">
                A differenza della versione cruda potrai
                <strong>conservare la pappa fuori dal frigo</strong> senza
                l’aggiunta di <strong>nessun conservante</strong> e come da
                perfetta tradizione casalinga
              </div>
              <div class="flex gap-6 items-center mt-4 w-5/6 mx-auto">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="h-14 w-14 text-red-600"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z"
                  />
                </svg>

                <div class="text-left">
                  <div
                    class="rb-subtitle-font text-3xl text-red-600 leading-tight"
                  >
                    Conservazione fuori frigo
                  </div>
                  <div class="text-sm leading-tight">
                    Il nostro ragù cotto si mantiene tranquillamente fuori dal
                    frigo senza conservanti aggiunti
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-4" v-else>
              <div class="leading-tight">
                Ricordati che se sarà cruda, come nella
                <strong>perfetta tradizione “barf”</strong>, dovrai conservare
                la <strong>pappa in freezer</strong>.
              </div>
            </div>
          </label>
        </div>
        <div v-if="$v.form.foodPreparationMethodId.$error" class="error">
          campo obbligatorio
        </div>
        <a
          class="underline hidden md:inline-block text-sm italic py-2 cursor-pointer"
          v-on:click.stop="openModal()"
          >Maggiori info</a>
      </div>

      <VideoPopup
        ref="videopopup"
        :intervalTime="10"
        :videoDesktopUrl="videoDesktopUrl"
        :videoMobileUrl="videoMobileUrl"
      >
      </VideoPopup>
    </form>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import VideoPopup from "./VideoPopup.vue";
export default {
  components: { VideoPopup },
  props: {
    wizardData: {
      type: Object,
      required: true,
    },
    dogData: {
      type: Object,
      required: true,
    },
    listData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      videoDesktopUrl:
        "https://player.vimeo.com/video/783354965?h=318eec6af6",
      videoMobileUrl:
        "https://player.vimeo.com/video/783354324?h=2518fcfed3",
      foodPreparationMethods: this.listData.foodPreparationMethods,
      form: {
        foodPreparationMethodId: null,
      },
    };
  },
  validations: {
    form: {
      foodPreparationMethodId: {
        required,
      },
    },
  },
  methods: {
    getUrl(value) {
      return this.$hostname + "/" + value;
    },
    getImageUrl(value) {
      return this.getUrl("wp-content/uploads/2022/12/" + value);
    },
    openModal() {
      this.$refs.videopopup.openModal();
    },
    submit() {
      this.$v.$touch();
      return new Promise((resolve, reject) => {
        if (!this.$v.$invalid) {
          // if user changes food preparation method, recipe and double taste should be null
          if (
            this.form.foodPreparationMethodId !=
            this.wizardData.foodPreparationMethodId
          ) {
            this.dogData.recipeId = null;
            this.isDoubleTaste = null;
          }
          resolve({
            form: {
              foodPreparationMethodId: this.form.foodPreparationMethodId,
            },
          });
        } else {
          reject("invalid entry");
        }
      });
    },
  },
  activated() {
    this.form.foodPreparationMethodId = this.wizardData.foodPreparationMethodId;
    this.$v.$reset();
  },
};
</script>
